import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import {push} from 'react-router-redux';
import {Radio} from 'rmwc';

import * as styles from '../../styles';
import * as actions from './actions';


//Radium(Delivery);
export default class Delivery extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.state = {
            method: this.props.store.getIn(['main', 'delivery_method']),
        };
    }

    render() {
        return <div>
            {this.props.active
                ? <div style={{margin: '.5em', userSelect: 'none'}}>
                    <div>
                        {window.gettext('Delivery Method')}:
                        <br/>
                        {/* <label
                            key='delivery-0-label'
                            htmlFor='delivery-0'
                            style={{...styles.field, display: 'flex', alignItems: 'center', height: undefined}}>
                            <Radio
                                key='delivery-0'
                                id='delivery-0'
                                style={{float: 'right', marginLeft: '.5em'}}
                                checked={this.state.method === 0}
                                onChange={() => this.setState({method: 0})}
                            />
                            <div style={{float: 'right', width: '100%'}}>
                                <i
                                    key='delivery-0-info'
                                    className='fa-info-circle fa-lg'
                                    style={{float: 'left', ':hover': {position: 'relative'}}}>
                                    {Radium.getState(this.state, 'delivery-0-info', ':hover')
                                        ? <div style={styles.info}>
                                            {window.gettext('Bespoke post description')}
                                        </div> 
                                        : null
                                    }
                                </i>
                                <div style={{fontSize: '1.1em'}}>
                                    {window.gettext('Bespoke Post')}
                                </div>
                                <div style={{fontSize: '.9em', color: '#9a9a9a'}}>
                                    {this.props.deliveryPrices[0]
                                        ? this.props.deliveryPrices[0].persian() + ' ' + window.gettext('Tooman')
                                        : window.gettext('Free')
                                    }
                                </div>
                                <div style={{fontSize: '.8em', color: '#9a9a9a'}}>
                                    {window.gettext('Bespoke post description')}
                                </div>
                            </div>
                        </label>
                        <label
                            key='delivery-1-label'
                            htmlFor='delivery-1'
                            style={{...styles.field, display: 'flex', alignItems: 'center', height: undefined}}>
                            <Radio
                                key='delivery-1'
                                id='delivery-1'
                                style={{float: 'right', marginLeft: '.5em'}}
                                checked={this.state.method === 1}
                                onChange={() => this.setState({method: 1})}
                            />
                            <div style={{float: 'right', width: '100%'}}>
                                <i
                                    key='delivery-1-info'
                                    className='fa-info-circle fa-lg'
                                    style={{float: 'left', ':hover': {position: 'relative'}}}>
                                    {Radium.getState(this.state, 'delivery-1-info', ':hover')
                                        ? <div style={styles.info}>
                                            {window.gettext('Pishtaz post description')}
                                        </div> 
                                        : null
                                    }
                                </i>
                                <div style={{fontSize: '1.1em'}}>
                                    {window.gettext('Pishtaz Post')}
                                </div>
                                <div style={{fontSize: '.9em', color: '#9a9a9a'}}>
                                    {this.props.deliveryPrices[1]
                                        ? this.props.deliveryPrices[1].persian() + ' ' + window.gettext('Tooman')
                                        : window.gettext('Free')
                                    }
                                </div>
                                <div style={{fontSize: '.8em', color: '#9a9a9a'}}>
                                    {window.gettext('Pishtaz post description')}
                                </div>
                            </div>
                        </label> */}
                         <label
                            key='delivery-1-label'
                            htmlFor='delivery-1'
                            style={{...styles.field, display: 'flex', alignItems: 'center', height: undefined}}>
                            <Radio
                                key='delivery-1'
                                id='delivery-1'
                                style={{float: 'right', marginLeft: '.5em'}}
                                checked={this.state.method === 1}
                                onChange={() => this.setState({method: 1})}
                            />
                            <div style={{float: 'right', width: '100%'}}>
                                <i
                                    key='delivery-1-info'
                                    className='fa-info-circle fa-lg'
                                    style={{float: 'left', ':hover': {position: 'relative'}}}>
                                    {Radium.getState(this.state, 'delivery-1-info', ':hover')
                                        ? <div style={styles.info}>
                                            {window.gettext('Post Delivery description')}
                                        </div> 
                                        : null
                                    }
                                </i>
                                <div style={{fontSize: '1.1em'}}>
                                    {window.gettext('Post Delivery')}
                                </div>
                                <div style={{fontSize: '.9em', color: '#9a9a9a'}}>
                                    {this.props.deliveryPrices[1]
                                        ? this.props.deliveryPrices[1].persian() + ' ' + window.gettext('Tooman')
                                        : window.gettext('Free')
                                    }
                                </div>
                                <div style={{fontSize: '.8em', color: '#9a9a9a'}}>
                                    {window.gettext('Post Delivery description')}
                                </div>
                            </div>
                        </label>
                        {/* <div
                            key='delivery-2-label'
                            htmlFor='delivery-2'
                            style={{...styles.field, height: undefined}}>
                            <div style={{fontSize: '1.1em'}}>
                                {window.gettext('Mass Delivery')}
                                <span style={{color: 'red'}}>(سفارشات کتاب بالای 20 جلد ویژه کتاب فروشی ها)</span>
                            </div>
                            <label
                                htmlFor='delivery-2'
                                style={{display: 'flex', alignItems: 'center'}}>
                                <Radio
                                    key='delivery-2'
                                    id='delivery-2'
                                    style={{float: 'right', marginLeft: '.5em'}}
                                    checked={this.state.method === 2}
                                    onChange={() => this.setState({method: 2})}
                                />
                                <div style={{float: 'right', width: '100%'}}>
                                    <i
                                        key='delivery-2-info'
                                        className='fa-info-circle fa-lg'
                                        style={{float: 'left', ':hover': {position: 'relative'}}}>
                                        {Radium.getState(this.state, 'delivery-2-info', ':hover')
                                            ? <div style={styles.info}>
                                                {window.gettext('Transportation description')}
                                            </div> 
                                            : null
                                        }
                                    </i>
                                    <div style={{fontSize: '1.1em'}}>
                                        {window.gettext('Transportation')}
                                    </div>
                                    <div style={{fontSize: '.9em', color: '#9a9a9a'}}>
                                        {this.props.deliveryPrices[2]
                                            ? this.props.deliveryPrices[2].persian() + ' ' + window.gettext('Tooman')
                                            : window.gettext('Free')
                                        }
                                    </div>
                                </div>
                            </label>
                            <label
                                key='delivery-3-label'
                                htmlFor='delivery-3'
                                style={{display: 'flex', alignItems: 'center'}}>
                                <Radio
                                    key='delivery-3'
                                    id='delivery-3'
                                    style={{float: 'right', marginLeft: '.5em'}}
                                    checked={this.state.method === 3}
                                    onChange={() => this.setState({method: 3})}
                                />
                                <div style={{float: 'right', width: '100%'}}>
                                    <i
                                        key='delivery-3-info'
                                        className='fa-info-circle fa-lg'
                                        style={{float: 'left', ':hover': {position: 'relative'}}}>
                                        {Radium.getState(this.state, 'delivery-3-info', ':hover')
                                            ? <div style={styles.info}>
                                                {window.gettext('Terminal description')}
                                            </div> 
                                            : null
                                        }
                                    </i>
                                    <div style={{fontSize: '1.1em'}}>
                                        {window.gettext('Terminal')}
                                    </div>
                                    <div style={{fontSize: '.9em', color: '#9a9a9a'}}>
                                        {this.props.deliveryPrices[3]
                                            ? this.props.deliveryPrices[3].persian() + ' ' + window.gettext('Tooman')
                                            : window.gettext('Free')
                                        }
                                    </div>
                                </div>
                            </label>
                        </div> */}
                    </div>
                </div>
                : <div>
                    {window.gettext('Delivery Method')}:&nbsp;
                    {this.state.method !== null
                        ? {
                            // 0: window.gettext('Bespoke Post'),
                            // 1: window.gettext('Pishtaz Post'),
                            1 : window.gettext('Post Delivery'),
                            // 2: window.gettext('Transportation'),
                            // 3: window.gettext('Terminal'),
                        }[this.state.method]
                        : '-'
                    }
                </div>
            }
            {this.props.active
                ? <div>
                    <button
                        style={{
                            ...styles.defaultButton,
                            float: 'left',
                            marginLeft: '.5em',
                        }}
                        onClick={() => {
                            if (this.state.method === null) {
                                alert(window.gettext('Incomplete data'));
                                return;
                            }
                            this.context.store.dispatch([
                                actions.setDeliveryMethod(this.state.method),
                                push({
                                    pathname: '/store/purchase/next/',
                                    query: this.props.location.query,
                                }),
                            ]);
                        }}>
                        {window.gettext('Confirm')}
                    </button>
                </div>
                : null
            }
        </div>;
    }
}
